import * as React from "react";
import { useEffect, useState } from "react";
import { CarouselCard } from "../../model/RegionLoginContent.model";
import { LoginContentApi } from "../../api/LoginContentApi";

const CAROUSEL_ROTATE_INTERVAL_MS = 7000;

interface LoginLandingCarouselProps {
    cards: CarouselCard[];
}

export const LoginLandingCarousel: React.FunctionComponent<LoginLandingCarouselProps> = ({ cards }) => {
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        setActiveSlide(0);
    }, [cards]);

    useEffect(() => {
        if (cards.length <= 1) {
            return undefined;
        }
        const timer = setInterval(() => {
            setActiveSlide((previous) => (previous + 1) % cards.length);
        }, CAROUSEL_ROTATE_INTERVAL_MS);
        return () => clearInterval(timer);
    }, [cards.length]);

    return (
        <div className="landing-page__carousel-section" data-testid="landing-carousel-cards">
            <div className="landing-page__carousel">
                {cards.map((card, index) => (
                    <div
                        key={index}
                        className={`landing-page__slide${index === activeSlide ? " landing-page__slide--active" : ""}`}
                    >
                        <div className="landing-page__slide-card">
                            {card.imageDocumentId && (
                                <div className="landing-page__slide-image">
                                    <img
                                        src={LoginContentApi.carouselImageUrl(card.imageDocumentId)}
                                        alt={card.headline}
                                    />
                                    {card.badge !== "NO_BADGE" && (
                                        <span className={`landing-page__slide-badge landing-page__slide-badge--${card.badge.toLowerCase()}`}>
                                            {card.badge}
                                        </span>
                                    )}
                                </div>
                            )}
                            <div className="landing-page__slide-text">
                                <h3 className="landing-page__slide-headline">{card.headline}</h3>
                                {card.description && (
                                    <p className="landing-page__slide-description">{card.description}</p>
                                )}
                                {/* eslint-disable-next-line react/forbid-dom-props */}
                                <a className="landing-page__slide-cta" href={card.ctaUrl}
                                   target="_blank" rel="noopener noreferrer">
                                    {card.ctaLabel} &rarr;
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {cards.length > 1 && (
                <div className="landing-page__carousel-dots">
                    {cards.map((_card, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`landing-page__dot${index === activeSlide ? " landing-page__dot--active" : ""}`}
                            onClick={() => setActiveSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
